import i18n from 'i18next';
import { typesOfSaleStatistic } from '../../filters/MePosSaleFilters/constants';

export const formatNumber = (num) => {
  if (num == null || isNaN(Number(num))) return '0';
  return Number(num).toLocaleString();
};

export const formatMoney = (num, currency = '') => {
  const value = Number(num);
  const roundedValue = Number.isFinite(value) ? value.toFixed(2) : (0).toFixed(2);
  return currency ? `${roundedValue} ${currency}` : roundedValue;
};

export const pickNumber = (bucket = {}, names = []) => {
  if (!bucket || !Array.isArray(names)) return 0;

  for (const name of names) {
    const value = bucket[name];
    if (value == null) continue;

    if (typeof value === 'number') return value;
    if (typeof value?.value === 'number') return value.value;
    if (!isNaN(Number(value))) return Number(value);
  }

  return 0;
};

export const createDebounce = (fn, wait = 300) => {
  let timer;
  const debounced = (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), wait);
  };
  debounced.cancel = () => clearTimeout(timer);
  return debounced;
};

export const getFirstSubAggregationKey = (bucket, subAggName) => {
  const subAgg = bucket?.[subAggName];
  return subAgg?.buckets?.[0]?.key ?? '';
}

export const convertAggregationBucketsToOptions = (buckets = [], options = {}) => {
  const { valueKey = 'key', labelFields = [], idToString = true } = options;

  return buckets.map((bucket) => {
    const rawKey = bucket[valueKey];
    const key = idToString ? String(rawKey ?? '') : rawKey;

    let label = '';
    if (labelFields.length > 0) {
      label = labelFields
        .map(field => getFirstSubAggregationKey(bucket, field))
        .filter(Boolean)
        .join(' ')
        .trim();
    }

    if (!label && rawKey != null) {
      label = String(rawKey);
    }

    return { key, label };
  });
}

export const convertAggWarehousesBucketsToOptions = (buckets = []) =>
  buckets.map(b => ({
    key: String(b.key ?? ''),
    label: String(b.warehouseName?.buckets?.[0]?.key ?? b.key ?? ''),
    deleted: !!b.warehouseDeleted?.buckets?.[0]?.key,
  }));

export const maybeTranslate = (val, options = {}) => {
  if (!val) return '';
  if (!i18n || !i18n.isInitialized) return val;
  try {
    return i18n.exists(val) ? i18n.t(val, options) : val;
  } catch {
    return val;
  }
}

export const formatCurrency = (num, currency) => {
  const formatted = formatNumber(num);
  return currency ? `${formatted} ${currency}` : formatted;
};

export const getTypeForDisplay = (statKey) => {
  const foundType = typesOfSaleStatistic.find((item) => item.key === statKey);
  if (foundType) {
    return foundType.label;
  }
  return statKey;
};